module.exports = __webpack_public_path__ + "static/avatar_mitya_fomin-4b9ab3dd7abe7681e8f0022a4b22a907.jpg";